import { IUpdateChecklistServicoAmbienteUseCase } from "../../../presentation/useCases/update/update_checklist_servico_ambiente_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateChecklistServicoAmbienteUseCase
 */

export class UpdateChecklistServicoAmbienteUseCase implements IUpdateChecklistServicoAmbienteUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServicoAmbiente: number,
    descricao?: string | null,
    ordem?: string | null,
  ): Promise<void> {
    await this.repository.updateChecklistServicoAmbiente(
      idChecklistServicoAmbiente,
      descricao,
      ordem,
    );
  }
}
